import React from 'react'
import styles from './EventsDoughnut.module.scss'
import { Checkbox } from 'components/shared/Checkbox'
import { Doughnut } from 'components/charts/Doughnut/DoughnutChart'
import {
  // STATISTIC_STORE,
  // EXPENSES_EVENTS_LABELS,
  // INTERACTION_EVENTS_LABELS,
  // LEGEND_COLORS,
  // EXPENSES_EVENTS,
  STATISTICS_OVERVIEW_BAR_CHART_STORE
} from 'store'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { EventsDoughnutProps } from './EventsDoughnut.types'
import { Text1 } from 'components/shared'

const EventsDoughnutComponent = (props: EventsDoughnutProps) => {
  // const type = props.type

  const {
    // [STATISTIC_STORE]: {
    //   // totalInteractionByEvents,
    //   // totalRevenueByEvents,
    //   // totalEventsRevenue,
    //   // totalEventsCount,
    //   selectedEventsIndex
    // },
    [STATISTICS_OVERVIEW_BAR_CHART_STORE]: {
      eventsDoughnutProps,
      eventsDoughnutLegend,
      isEventSelected,
      onExpandableSectionEventCheckboxClick
    }
  } = props

  // const legendColors = ['#3AABF2', '#254291', '#70D6C6', '#2985AE', '#B021D9', '#2D65FF']
  // const doughnutData = []

  // const setDoughnutData = () => {
  //   if (type === 'EXPENSES') {
  //     totalRevenueByEvents.forEach((value, key) => {
  //       doughnutData.push({ label: key, value })
  //     })
  //   } else {
  //     totalInteractionByEvents.forEach((value, key) => {
  //       doughnutData.push({ label: key, value })
  //     })
  //   }
  // }

  // setDoughnutData()

  // const total: number = type === 'EXPENSES' ? totalEventsRevenue : totalEventsCount

  // const onCheckBox = (index: number) => {
  //   if (selectedEventsIndex.has(index)) {
  //     selectedEventsIndex.delete(index)
  //   } else {
  //     selectedEventsIndex.add(index)
  //   }
  // }

  return (
    <div className={styles.container}>
      <Doughnut {...eventsDoughnutProps} />
      <div className={styles.legendContainer}>
        {eventsDoughnutLegend.map(({ color, label, value, eventType }, index) => {
          return (
            <div className={styles.legendEntry} key={'doh_label' + index} >
              <Checkbox
                isChecked={isEventSelected(eventType)}
                // className={styles.checkbox}
                fillColor={color}
                onClick={() => onExpandableSectionEventCheckboxClick(eventType)}
                style={{ backgroundColor: color }}
              />
              <Text1
                overflowEllipsis
                className={styles.legendLabel}
              >
                {label}
              </Text1>
              <Text1
                bold
                className={styles.legendValue}
              >
                {value}
              </Text1>
            </div>)
        })
        }
      </div>
    </div>
  )
}

const EventsDoughnut = inject(
  // STATISTIC_STORE,
  STATISTICS_OVERVIEW_BAR_CHART_STORE
)(observer(EventsDoughnutComponent))
export { EventsDoughnut }
